import type { ToteEngagementMode } from '@mote/api'
import { SITE_URL } from '@mote/helpers/constants'

export function getMemeSrc(mode: ToteEngagementMode, image: string): string {
  return `${SITE_URL}images/loop_memes/${mode}/${image}`
}
